import { getAxiosConfigUserToken } from "app/utils/appHelpers";
import axios from "axios";
import config from "config";


export const sendMailByMeetingIdPDFApi = async (
    id,
    infoType = "false",
    notType = "false",
    attachmentType = "false",
    mailText = null,
    smsText = null,
    extraFileId = null,
    extraFileExt = null,
    extraFileName = null,
    inst = null,
    userIds = null,
    personalizeByName = false
) => {
    const url = `${config.apiUrl}/v1/notification/${id}/${infoType}/${notType}/${attachmentType}`;
    return axios.post(url, {
        mailText,
        smsText,
        extraFileId,
        extraFileExt,
        extraFileName,
        inst,
        userIds,
        personalizeByName
    }, {
        responseType: 'blob',
        ...getAxiosConfigUserToken()
    }).then(res => new Blob([res.data], { type: 'application/pdf' }));
}

export const sendOneRecordMailApi = async ({ meetingId, decisionId, type, userIds, mailText, subject }) => {
    const url = `${config.apiUrl}/v1/notification/oneRecordMail`;
    return axios.post(url, {
        meetingId,
        decisionId,
        type,
        userIds,
        mailText,
        subject
    }, getAxiosConfigUserToken())
        .then(response => response.data)
        .catch(err => ({
            status: false,
            message: err?.response?.data?.message || "E-posta gönderilemedi"
        }));
}
